import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "@phosphor-icons/react";
import { api } from "@/lib/api";

const fmtDate = (iso) => iso ? new Date(iso).toLocaleDateString("en-CA", { year: "numeric", month: "long", day: "numeric" }) : "";

export default function BlogPage() {
  const nav = useNavigate();
  const [posts, setPosts] = useState(null);
  useEffect(() => {
    document.title = "Blog — The Self-Agency Project";
    api.get("/site/blog").then(({ data }) => setPosts(data)).catch(() => setPosts([]));
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white" style={{ fontFamily: "Manrope, sans-serif" }} data-testid="blog-page">
      <header className="max-w-5xl mx-auto px-5 pt-8 flex items-center justify-between">
        <button onClick={() => nav("/")} className="bg-transparent border-0 text-[#A1A1AA] hover:text-white cursor-pointer flex items-center gap-2 text-sm" data-testid="blog-back-home">
          <ArrowLeft size={16} /> selfagency.ca
        </button>
        <div style={{ fontFamily: "Anton, sans-serif" }} className="text-lg">THE SELF-AGENCY <span className="text-[#FFE01A]">PROJECT</span></div>
      </header>
      <main className="max-w-5xl mx-auto px-5 py-12">
        <h1 style={{ fontFamily: "Anton, sans-serif" }} className="text-4xl sm:text-5xl uppercase mb-2">The <span className="text-[#FFE01A]">Blog</span></h1>
        <p className="text-[#D4D4D8] mb-10 max-w-xl">Practical safety, de-escalation and self-agency — straight from the mats and the classroom.</p>
        {posts === null && <p className="text-[#A1A1AA]">Loading…</p>}
        {posts?.length === 0 && <p className="text-[#A1A1AA]" data-testid="blog-empty">First articles are on the way — check back soon.</p>}
        <div className="grid sm:grid-cols-2 gap-6">
          {(posts || []).map((p) => (
            <article key={p.id} onClick={() => nav(`/blog/${p.slug}`)}
              className="group cursor-pointer border border-white/10 hover:border-[#FFE01A]/60 bg-white/[0.03] overflow-hidden transition-colors"
              data-testid={`blog-card-${p.slug}`}>
              {p.cover_url && <img src={p.cover_url} alt={p.title} className="w-full h-48 object-cover" />}
              <div className="p-5">
                <div className="text-[#FFE01A] text-xs uppercase tracking-widest mb-1.5">{fmtDate(p.published_at)}</div>
                <h2 className="text-lg font-extrabold leading-snug mb-2 group-hover:text-[#FFE01A] transition-colors">{p.title}</h2>
                {p.excerpt && <p className="text-[#D4D4D8] text-sm leading-relaxed">{p.excerpt}</p>}
                <div className="mt-3 text-sm font-bold text-[#FFE01A] flex items-center gap-1">
                  Read article <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </main>
    </div>
  );
}
